export const works=[
    {
        Title:"|Agentic AI Due Diligence|Coming soon",
        Summary:[],
        ContextItems:[],
        Assets:"citi"
    },
    {
        Title:"Wetland Digitalization Tool|Geospatial planning and documentation|5 min read",
        Hashtag:"#UserFreedom  #Constrains  #UAT  #GIS",
        Summary:
        [
            {
                line1:"Co-developed a USDA <b>Design System</b>",
                line2:"> Adopted by Multiple Branches",
            },
            {
                line1:"Restructured GIS <b>Layers & Data</b>",
                line2:"> -40% Supporting Tickets",
            },
            {
                line1:"Built <b>Self-guided UI</b>",
                line2:"> +35% Faster Completion",
            }
        ],
        Assets:"wdt",
        ContextItems:
        [
            {
                steps:
                [ 
                    {
                        step_text:"Problem statement",
                        step_link:"problem_statement"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Discovery Research",
                        step_link:"research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Design Challenges",
                        step_link:"challenges"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Enhancements",
                        step_link:"enhancements"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Validation",
                        step_link:"validation"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impacts",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
    {
        Title:"Field Office Technical Guide|AI-powered Information Repository|6 min read",
        Hashtag:"#Research  #UsabilityTest  #Section508",
        Summary:
        [
            {
                line1:"Led <b>Mobile-first Redesign</b>",
                line2:"> +37% Mobile Usage",
            },
            {
                line1:"Spearheaded <b>Smarter Search</b>",
                line2:"> -33% Search Bounce",
            },
            {
                line1:"Introduced <b>RAG AI Assistants</b>",
                line2:"> +300% Information Findability",
            }
        ],
        Assets:"fotg",
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Problem statement",
                        step_link:"problem_statement"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Discovery research",
                        step_link:"discovery_research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Change of Direction",
                        step_link:"change"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Usability Test",
                        step_link:"test"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Mobile-First UI",
                        step_link:"mobile"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"AI Widgets",
                        step_link:"ai"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impact",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
    {
        Title:"Small Business Development Center|Public Service Platform|5 min read",
        Hashtag:"#NavigationTest   #VisualHierarchy  #WCAG",
        Summary:
        [
            {
                line1:"Drove <b>Responsive Redesign</b>",
                line2:"> +50% Mobile Traffic",
            },
            {
                line1:"Reorganized <b>Information Architecture</b>",
                line2:"> +62% Session Depth",
            },
            {
                line1:"Optimized <b>Booking Flow</b>",
                line2:"> +29% Appointment Booking",
            }
        ],
        Assets:"sbdc",
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Context",
                        step_link:"context"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Research",
                        step_link:"research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Strategy",
                        step_link:"strategy"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Enhancements",
                        step_link:"enhancements"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impacts",
                        step_link:"impacts"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
    {
        Title:"Conservation Practice Document Document Management System|Document Management System|3 min read",
        Hashtag:"#StakeholderCollaboration #ContextualDesign",
        Summary:
        [
            {
                line1:"Introduced <b>Contextual Functions</b>",
                line2:"> +200% New User Task Success",
            },
            {
                line1:"<b>Consolidated Roles</b> and <b>Simplified Flows</b>",
                line2:"> +47% Faster Approval Cycles",
            },
            {
                line1:"Leveraged <b>SharePoint Integration</b>",
                line2:"> +30% Faster Editing",
            }
        ],
        Assets:"cpd_dms",
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Research",
                        step_link:"research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"User flows",
                        step_link:"user_flows"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Prototype",
                        step_link:"prototype"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impacts",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"takeaways"
                    }
                ]
            }
        ]
    }
]